import React from 'react';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';
// components
import { Modal } from '@tcc/crate';

const DriveModalError = (props) => {
  const baseString = 'vra-export-selector';
  const {open, toggleErrorDriveModal} = props; 
  return (
    <Modal
      onClose={() => {
        toggleErrorDriveModal(false);
      }}
      show={open}
      size="M">
      <div>
        <p className={`${baseString}__tittle`}>{getMessage('text__error--assign-prescription-tittle')}</p>
        <p className={`${baseString}__hd-txt-confirm`}>
          {getMessage('text__error--assign-prescription-txt')}
        </p>
      </div>
    </Modal>
  );
};

DriveModalError.propTypes = {
  open: propTypes.bool.isRequired,
  toggleErrorDriveModal: propTypes.func.isRequired
};

export default DriveModalError;
